
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import infoGetActions from '../../sagas/info';

const LinkToOpsub = (props) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const handleClick = () => {
        infoActions.getObjectOpsub(token, projectId, props.opsub.opsub_id);
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o vlastníkovi">{props.opsub.name}</Link>
    )
}

export default LinkToOpsub;
